'use client'

import { useCallback, useRef, useState } from 'react'

/** 같은 화면에서 진행 중인 작업이 끝날 때까지 추가 실행을 막는다. */
export function useAsyncAction() {
  const locked = useRef(false)
  const [busy, setBusy] = useState(false)
  const run = useCallback(async (action: () => Promise<void>) => {
    if (locked.current) return
    locked.current = true
    setBusy(true)
    try {
      await action()
    } finally {
      locked.current = false
      setBusy(false)
    }
  }, [])
  return { busy, run }
}
